var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _vm.showMsg || _vm.showMsgSuccess
      ? _c("div", { staticClass: "row" }, [
          _vm.showMsg
            ? _c(
                "div",
                {
                  staticClass: "alert alert-danger alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.msg) + "\n      "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMsg()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showMsgSuccess
            ? _c(
                "div",
                {
                  staticClass:
                    "alert alert-success alert-dismissible fade show",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v("\n      " + _vm._s(_vm.msgSuccess) + "\n      "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Fechar"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.hideMsg()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.images
      ? _c(
          "div",
          { staticClass: "row pictures" },
          _vm._l(_vm.images, function(i, k) {
            return _c("div", { key: k, staticClass: "col-md-3" }, [
              _c("img", {
                attrs: { src: i.url },
                on: {
                  click: function($event) {
                    return _vm.removeImage(i.ImageId)
                  }
                }
              })
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "button",
          {
            staticClass: "btn",
            on: {
              click: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.selectImage()
              }
            }
          },
          [_vm._v("Adicionar Imagem")]
        ),
        _vm._v(" "),
        _c("input", {
          ref: "uploadBtnImage",
          staticClass: "input-image",
          attrs: { type: "file" },
          on: { change: _vm.uploadImage }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("span", [
          _vm._v(
            "\n        Cadastre imagens para exibir na galeria do projeto. Limite de até 9 fotos.\n      "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-165c1e54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-165c1e54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/manage-project/Images.vue
// module id = null
// module chunks = 